<template>
    <div v-show="show" class="changeTime-container">
        <div v-show="showEdit" class="dialogContent">
            <div class="title">可发送上屏时间超时，请重新设置上屏时间</div>
            <date-picker class="datePickerDom" :type="'datetime'" :format="'YYYY-MM-DD HH:mm:ss'" v-model="datePicker"  placeholder="请选择上屏时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" :disabledDays="disabledDate" confirm></date-picker>
            <div class="btns">
                <p @click="confirm" class="btn g">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { Switch } from 'element-ui'
import { apis } from "@common/config";
import common from "@common/common";
export default {
    components: {
        DatePicker,
        'el-switch': Switch
    },
    data() {
        return {
            canUploadUrl: '',
            _XN_upCfg: null,
            appId: null,
            appSecret: null,
            uploadUrl: null,
            circleList: [],
            showEdit: true,
            cover: '',
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空',
            times: "1",
            date: "15",
            priority: '1',
            isCycle: false,
            datePicker: '',
            img_list: [],
            cycleTimes: [],
            saveCover: '',
            hasUrl: false
        }
    },
    methods: {
        getNewImg(res) {
            console.log(res.url)
            this.saveCover = res.url
            this.processCoverImage(res.url);
            this.hasUrl = false;
        },
        setCover(url){
            this.cover = url
            this.hasUrl = false;
        },
        editPic(){
            this.$sportPicEdit({
                url: this.saveCover
            },this.setCover)
        },
        openImg (urlList) { 
            console.log(33213123,urlList)
            this.$libraryMaterialImgList(urlList, this.getNewImg).then(res => { 
                this.getNewImg(res)
            })
        },
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            this.show = true;
            this.calculateDefaultTime()

            setTimeout(() => {
                let dom = document.querySelectorAll('.datePickerDom .mx-datepicker-popup .mx-panel-time .mx-time-list')
                if(dom.length){
                    dom = dom[1]

                    let list = dom.querySelectorAll('.cell')

                    for(let i = 0; i < list.length; i++){ 
                        let item = list[i]
                        if(item.innerText != '00' &&item.innerText != '15' && item.innerText != '30' && item.innerText != '45' ){
                            item.style.display = 'none'
                        }
                    }
                }
            }, 500)
        },
        calculateDefaultTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth();
            const day = now.getDate();
            const hour = now.getHours();
            const minute = now.getMinutes();
            
            let targetHour = hour;
            let targetDay = day;
            
            if (minute < 55) {
                // 当前时间（非55分）的下一个准点
                targetHour = hour + 1;
            } else {
                // 当前时间（55-60分）的下二个准点
                targetHour = hour + 2;
            }
            
            // 处理跨天的情况
            if (targetHour >= 24) {
                targetHour -= 24;
                targetDay += 1;
            }
            
            // 创建目标时间
            const targetDate = new Date(year, month, targetDay, targetHour, 0, 0);
            
            // 格式化时间为 YYYY-MM-DD HH:mm 格式
            const formattedDate = this.formatDate(targetDate);
            this.datePicker = formattedDate;
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hour}:${minute}:00`;
        },
        disabledDate(date) {
            // 禁用今天之前的日期，允许选择今天
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            // For vue2-datepicker, date is already a Date object
            const targetDate = new Date(date);
            targetDate.setHours(0, 0, 0, 0);
            
            return targetDate.getTime() < today.getTime();
        },
        getDetail() {
            
            let data = {
                doc_id: this.config ? this.config.id : '',
                from_req: 1
            }
            common.myFetch(apis.sourceDocDetail,data).then(res => {
                console.log(res)
                if (res) {
                    // 处理封面图片，根据宽高比进行截取
                    if (res.cover) {
                        this.saveCover = res.cover
                        this.processCoverImage(res.cover);
                    }
                    this.content = res.title;
                    if(res.img_list){
                        this.img_list = res.img_list
                    }else{
                        this.img_list = []
                    }
                }
            })
        },
        processCoverImage(coverUrl) {
            // 创建图片对象来获取宽高
            const img = new Image();
            img.onload = async () => {
                const width = img.width;
                const height = img.height;
                const aspectRatio = width / height;
                const targetRatio = 16 / 9;
                
                let processedUrl = coverUrl;
                
                if (aspectRatio >= targetRatio) {
                    // 横图：按高截取成16:9
                    // 计算需要截取的宽度
                    const targetWidth = height * targetRatio;
                    const offsetX = (width - targetWidth) / 2;
                    // 生成截取后的URL
                    processedUrl = await this.addImageProcessParams(coverUrl, {
                        cropWidth: Math.round(targetWidth),
                        cropHeight: height,
                        x: Math.round(offsetX),
                        y: 0
                    });
                } else {
                    // 竖图：按宽截取成16:9
                    // 计算需要截取的高度
                    const targetHeight = width / targetRatio;
                    const offsetY = (height - targetHeight) / 2;
                    // 生成截取后的URL
                    processedUrl = await this.addImageProcessParams(coverUrl, {
                        cropWidth: width,
                        cropHeight: Math.round(targetHeight),
                        x: 0,
                        y: Math.round(offsetY)
                    });
                }
                
                this.cover = processedUrl;
            };
            img.src = coverUrl;
        },
        addImageProcessParams(url, params) {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const { cropWidth, cropHeight, x, y } = params;
                    canvas.width = cropWidth;
                    canvas.height = cropHeight;
                    ctx.drawImage(img, x, y, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                    const processedUrl = canvas.toDataURL('image/jpeg');
                    resolve(processedUrl);
                };
                img.src = url;
            });
        },
        confirm() {
            let screenTime;
            // Check if datePicker is a timestamp (number)
            if (typeof this.datePicker === 'number') {
                // Convert timestamp to Date object first, then format
                screenTime = common.stampToTime(new Date(this.datePicker));
            } else if (this.datePicker instanceof Date) {
                // If it's already a Date object, use stampToTime
                screenTime = common.stampToTime(this.datePicker);
            } else {
                // If it's already a string, return it directly
                screenTime = this.datePicker;
            }
            
            let data = {
                screen_time: screenTime,
                id: this.config.id
            }
            const url = this.config.api || apis.consultUpdateScreenTime
            common.myFetch(url,data).then(res => {
                if (res) {
                    this.$toast('修改成功');
                    this.callback(true)
                    this.show = false;
                }
            })
        },
        cancel() {
            this.$confirm('是否确定取消？取消后任务将被删除。').then((res) => {
                if(res){
                    this.show = false;
                    this.$newLibraryMaterial().close()
                }
            })
        },
        async close() {
            this.show = false;
            this.callback(false)
        },
        handleDateChange(value) {
            if (value) {
                const date = new Date(value);
                let minutes = date.getMinutes();
                
                // Round to nearest 00, 15, 30, or 45 minutes
                const roundedMinutes = Math.round(minutes / 15) * 15;
                
                // Handle case where rounding goes to 60 minutes
                if (roundedMinutes === 60) {
                    date.setHours(date.getHours() + 1);
                    date.setMinutes(0, 0, 0);
                } else {
                    date.setMinutes(roundedMinutes, 0, 0);
                }
                
                // Format back to yyyy-MM-dd HH:mm
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const formattedMinutes = String(date.getMinutes()).padStart(2, '0');
                
                this.datePicker = `${year}-${month}-${day} ${hour}:${formattedMinutes}`;
            }
        },
        calculateCycleTimes() {
            if (!this.isCycle || !this.datePicker) {
                this.cycleTimes = [];
                return;
            }
            
            const cycleTimes = [];
            const startTime = new Date(this.datePicker);
            const intervalMinutes = parseInt(this.date);
            const cycleCount = parseInt(this.times);
            
            for (let i = 0; i <= cycleCount; i++) {
                const currentTime = new Date(startTime);
                currentTime.setMinutes(startTime.getMinutes() + (i * intervalMinutes));
                
                // Format time as YYYY-MM-DD HH:mm
                const year = currentTime.getFullYear();
                const month = String(currentTime.getMonth() + 1).padStart(2, '0');
                const day = String(currentTime.getDate()).padStart(2, '0');
                const hour = String(currentTime.getHours()).padStart(2, '0');
                const minute = String(currentTime.getMinutes()).padStart(2, '0');
                
                cycleTimes.push(`${year}-${month}-${day} ${hour}:${minute}`);
            }
            
            this.cycleTimes = cycleTimes;
        },
        addAssetsToPage(data) {
            // console.log('更新到接口', data,this.t);
            const filelist = [];
            data.forEach(i => {
                // console.log(i)
                const type = 1;
                // 将文件名改为截取前40位加后缀名
                const fileName = i.pureName || i.title || i.filename || i.name || "";
                const nameParts = fileName.split(".")[0];
                const ext = i.path.split('/').pop().split('.').pop();
                let nameLeft = nameParts;
                nameLeft = nameLeft.substr(0, 40);
                const filetitle = `${nameLeft}.${ext}`;
                // console.log(filetitle)
                let file = {
                    type: type,
                    title: filetitle,
                    path: i.targetPath || i.path,
                    subject_id: '',
                    subject_type: ''
                };
                

                filelist.push(file);
            });

            const info = { file_info: JSON.stringify(filelist) };
            return common.myFetch(apis.File_add, info).then(r => {
                if (r) {
                    this.$imgLoading.close()
                    this.hasUrl = true;
                    this.canUploadUrl = r.list[0].download_url;
                    let data = {
                        img_url: this.canUploadUrl,
                        title: this.content,
                        screen_time: this.datePicker,
                        priority: this.priority,
                        is_cycle_screen: this.isCycle ? 1 : 0,
                        cycle_count: this.times,
                        interval_time: this.date,
                        unified_content_id: this.config.id
                    }
                    common.myFetch(apis.consultPush,data).then(res => {
                        if (res) {
                            this.$toast('新建成功');
                            this.cover = '';
                            this.saveCover = '';
                            this.content = '';
                            this.priority = '1';
                            this.datePicker = '';
                            this.times = '1'
                            this.date = '15'
                            this.show = false;
                            this.isCycle = false
                        }
                    })
                    console.log(r)
                }else{
                    this.$imgLoading.close()
                }
            });
        },
        streamUpload(name, file) {
            // console.log(file)
            var that = this;
            var upConfig = this._XN_upCfg
            var filename = name
            var uniname = common.uniKey()
            var platform = common.getPlatform()
            var ext = 'jpg'
            var fileNameId = upConfig.fileNameId
            var httpPath = upConfig.httpPath
            var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext
            if(!name){
                name = fileNameId + platform + uniname + '.' + ext
            }
            const info = { 
                targetPath: path,
                appId: this.appId,
                appSecret: this.appSecret
            };

            var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
            var _xhr = new XMLHttpRequest;

            _xhr.ontimeout = function () {
                console.error('The request for ' + _url + ' timed out.');
            };

            _xhr.onreadystatechange = function() {
                // console.log(_xhr.responseText)
                if (_xhr.readyState != 4 || _xhr.status < 200)
                return false;
                let data = JSON.parse(_xhr.responseText)
                if(data.success){
                    // console.log(data)
                    data.targetPath = data.path;
                    data.name = name;
                    that.addAssetsToPage([data])
                }else{
                    this.$imgLoading.close()
                    this.showSelect = false;
                    this.showFail = true;
                    this.canEditImg = true
                    this.alertWord = '网络连接超时'
                }
            }

            _xhr.timeout = 60 * 1000;
            _xhr.open("POST", _url, !0);
            _xhr.send(file);
        },
        getConfig() {
            return common.getFileConfigs()
            .then(r => {
                this.appId = r.app_id
                this.appSecret = r.app_secret
                this.uploadUrl = r.url
            })
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return common.myFetch(apis.File_Aspera)
            .then(r => {
                if (r) {

                this._XN_upCfg = {
                    asperaPath: r.aspera_path,
                    httpPath: r.original_path,
                    fileNameId: r.filename_id
                }
                }
            })
        }
    },
    watch: {
        datePicker: {
            deep: true,
            handler: function (n) {
                this.calculateCycleTimes();
            }
        },
        times() {
            this.calculateCycleTimes();
        },
        date() {
            this.calculateCycleTimes();
        },
        isCycle() {
            this.calculateCycleTimes();
        }
    }
}
</script>

<style lang="less">
    @font-face {
        font-family: 'HYQiHei70S';
        src: url('/font/SourceHanSansCN-Bold.otf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    // 汉仪旗黑70s字体类
    .hyqihei70s {
        font-family: 'HYQiHei70S', sans-serif;
    }

    .changeTime-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .confirmContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 418px;
            height: 200px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 40px 30px 40px;
            box-sizing: border-box;

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .title {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 460px;
                height: 76px;
                background: rgba(255,191,0,0.15);
                margin-bottom: 20px;

                p {
                    font-weight: 500;
                    font-size: 20px;
                    color: #050F0F;
                    line-height: 28px;
                }
            }

            img {
                width: 416px;
                height: 234px;
                object-fit: contain;
            }

            .wordBg {
                display: flex;
                align-items: flex-start;
                flex-wrap: wrap;
                width: 416px;
                height: 108px;
                background: #39464F;
                font-family: 'HYQiHei70S', sans-serif;
                font-weight: normal;
                font-size: 40px;
                color: #FFFFFF;
                line-height: 48px;
                text-align: left;
                font-style: normal;
                letter-spacing: -2.5px;
                padding: 9px 10px;
                box-sizing: border-box;
                white-space: pre-wrap;
                word-break: break-all;
            }

            .notice {
                display: flex;
                align-items: center;
                margin-top: 14px;

                i {
                    width: 14px;
                    height: 14px;
                    background: url('./assets/notice.png') no-repeat;
                    background-size: cover;
                    margin-right: 8px;
                }

                span {
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 24px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }

        .dialogContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 418px;
            height: 200px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 46px 30px;
            box-sizing: border-box;

            &>.title {
                font-weight: bold;
                font-size: 16px;
                color: #050F0F;
                line-height: 22px;
                margin-bottom: 24px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .content {
                display: flex;
                width: 100%;
                flex: 1;
                min-height: 0;

                .left-container {
                    margin-right: 40px;

                    img {
                        min-width: 416px;
                        min-height: 234px;
                        max-width: 416px;
                        max-height: 234px;
                        object-fit: contain;
                    }

                    .noImg {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-width: 416px;
                        min-height: 234px;
                        max-width: 416px;
                        max-height: 234px;
                        background: #E7EBEB;

                        i {
                            display: block;
                            width: 20px;
                            height: 20px;
                            background: url('./assets/noImg.png') no-repeat;
                            background-size: cover;
                            background-position: center;
                            margin-bottom: 6px;
                        }

                        span {
                            font-size: 14px;
                            color: #C4CBD1;
                            line-height: 20px;
                        }
                    }

                    .wordBg {
                        display: flex;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        width: 416px;
                        height: 108px;
                        background: #39464F;
                        font-family: 'HYQiHei70S', sans-serif;
                        font-weight: normal;
                        font-size: 40px;
                        color: #FFFFFF;
                        line-height: 48px;
                        text-align: left;
                        font-style: normal;
                        letter-spacing: -2.5px;
                        padding: 9px 10px;
                        box-sizing: border-box;
                        white-space: pre-wrap;
                        word-break: break-all;
                    }

                    .notice {
                        display: flex;
                        align-items: center;
                        margin-top: 14px;

                        i {
                            width: 14px;
                            height: 14px;
                            background: url('./assets/notice.png') no-repeat;
                            background-size: cover;
                            margin-right: 8px;
                        }

                        span {
                            font-weight: 500;
                            font-size: 14px;
                            color: #666666;
                            line-height: 22px;
                        }
                    }
                }

                .right-container {
                    display: flex;
                    flex-direction: column;

                    .row {
                        display: flex;
                        margin-bottom: 20px;

                        &.center {
                            align-items: center;
                        }

                        .pt {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-right: 4px; 
                        }

                        .notice {
                            position: relative;
                            width: 16px;
                            height: 16px;
                            background: url('./assets/alert.png') no-repeat;
                            background-size: cover;
                            background-position: center;
                            margin-right: 16px;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                p {
                                    display: flex;
                                }
                            }

                            p {
                                position: absolute;
                                top: -44px;
                                left: -18px;
                                display: none;
                                justify-content: center;
                                align-items: center;
                                width: 158px;
                                height: 40px;
                                background: rgba(5, 10, 15, 0.8);
                                border-radius: 4px;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                            }
                        }

                        .mx-datepicker {
                            min-width: 264px;

                            input {
                                max-width: 264px !important;
                                min-width: 264px !important;
                                width: 264px;
                                height: 30px;
                                background: rgba(185,195,195,0.2);
                                border-radius: 2px;
                                outline: none;
                                border: none;
                                color: #323B4B;
                            }
                        }

                        .priority {
                            padding: 0 14px;
                            box-sizing: border-box;
                        }

                        .select {
                            display: flex;
                            align-items: center;
                            margin-left: 26px;

                            .title {
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 30px;
                                color: #323B4B;
                                margin-right: 8px;
                            }

                            .unit {
                                font-weight: bold;
                                font-size: 14px;
                                line-height: 30px;
                                color: #323B4B;
                                margin-left: 8px;
                            }

                            .preview {
                                position: relative;
                                width: 18px;
                                height: 18px;
                                background: url('./assets/preview.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-left: 10px;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: url('./assets/previewOn.png') no-repeat;
                                    background-size: cover;
                                    background-position: center;
                                    margin-left: 10px;

                                    .info {
                                        display: flex;
                                    }
                                }

                                .info {
                                    position: absolute;
                                    top: 24px;
                                    right: 0;
                                    display: none;
                                    flex-direction: column;
                                    width: 178px;
                                    padding: 16px 20px;
                                    box-sizing: border-box;
                                    background: rgba(5, 15, 15, 0.8);
                                    border-radius: 4px;

                                    span {
                                        font-weight: 500;
                                        font-size: 14px;
                                        color: #41B48C;
                                        line-height: 20px;
                                        margin-bottom: 10px;
                                    }

                                    p {
                                        font-size: 14px;
                                        color: #829191;
                                        line-height: 20px;
                                        margin-bottom: 12px;

                                        &:nth-last-of-type(1) {
                                            margin-bottom: 0;
                                        }
                                    }
                                }
                            }

                            .el-select {
                                width: 50px;
                                height: 30px;
                                border-radius: 2px;

                                .el-input {
                                    height: 100%;
                                    width: 100%;
                                }

                                .el-input__inner {
                                    padding: 0;
                                    height: 100%;
                                    width: 100%;
                                    background: rgba(185, 195, 195, 0.2);
                                    border: none;  
                                    padding-left: 8px;
                                    box-sizing: border-box; 
                                    color: #323B4B;
                                    max-height: 30px !important;
                                }

                                .el-select__caret {
                                    line-height: 30px;
                                }
                            }
                        }

                        & > input {
                            max-width: 264px !important;
                            min-width: 264px !important;
                            width: 264px;
                            height: 30px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            outline: none;
                            border: none;
                            color: #323B4B;
                            
                            &.priorty {
                                padding: 0 14px !important;
                                box-sizing: border-box;

                                &::placeholder {
                                    color: #B9C3C3;
                                }
                            }
                        }
                        
                        .t {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-right: 24px;
                        }

                        .pic {
                            width: 192px;
                            height: 108px;
                            border-radius: 4px;
                            margin-right: 13px;
                            object-fit: contain;
                        }

                        .noImg {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            width: 192px;
                            height: 108px;
                            background: #E7EBEB;

                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('./assets/noImg.png') no-repeat;
                                background-size: cover;
                                background-position: center;
                                margin-bottom: 6px;
                            }

                            span {
                                font-size: 14px;
                                color: #C4CBD1;
                                line-height: 20px;
                            }
                        }

                        .btns {
                            display: flex;
                            flex-direction: column;

                            .change {
                                display: flex;
                                align-items: center;
                                margin-bottom: 10px;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    width: 16px;
                                    height: 16px;
                                    background: url('./assets/change.png') no-repeat;
                                    background-size: cover;
                                    margin-right: 4px;
                                }

                                span {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #829191;
                                }
                            }

                            .clip {
                                display: flex;
                                align-items: center;
                                user-select: none;
                                cursor: pointer;

                                i {
                                    width: 16px;
                                    height: 16px;
                                    background: url('./assets/clip.png') no-repeat;
                                    background-size: cover;
                                    margin-right: 4px;
                                }

                                span {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #829191;
                                }
                            }
                        }
                    }

                    .col {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 20px;

                        .t {
                            font-weight: bold;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 20px;
                            margin-bottom: 10px;
                        }

                        textarea {
                            width: 404px;
                            height: 62px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            outline: none;
                            resize: none;
                            padding: 10px 14px;
                            box-sizing: border-box;
                            font-weight: 500;
                            font-size: 14px;
                            color: #323B4B;
                            line-height: 21px;
                        }
                    }
                }
            }

            & > .btns {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 30px auto 0;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    color: #FFF;
                    user-select: none;
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin-left: 20px;
                    }

                    &.g {
                        background: #41B48C;
                    }
                }
            }
        }
    }

    .timeOutSelect {
        .el-select-dropdown__item.selected {
            color: #41B48C;
        }
    }

    .createTimePoper .el-date-table td.current:not(.disabled) span {
        color: #FFF !important;
    }
</style>
